'use client';

import type { PropsWithChildren } from 'react';

import { withPromo } from '@/helpers/hocs';

function BonanzaPromoPage({ children }: PropsWithChildren) {
  return children;
}

export default withPromo(BonanzaPromoPage, {
  redirectUrl: '/',
  promoName: 'bonanzaPromo',
});
